import { Box, Chip } from '@mui/material';
import React from 'react';
import { Colors } from '../../../assets/theme/Colors';

const RouteChip = ({ isDonor, showIcon = false }) => (
  <Chip
    size="small"
    label={isDonor ? 'Pickup' : 'Drop-off'}
    sx={{
      bgcolor: isDonor ? '#d9e6e7' : '#fdeae1',
      color: isDonor ? Colors.primaryColor : Colors.appBar.main,
      fontWeight: 700,
      flexShrink: 0,
      userSelect: 'none',
      '& .MuiChip-label': { px: 1.25 },
    }}
    icon={
      showIcon ? (
        <Box
          sx={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            bgcolor: isDonor ? Colors.primaryColor : Colors.appBar.main,
            ml: '8px !important',
          }}
        />
      ) : null
    }
  />
);

export default RouteChip;
